import { useTranslation } from 'react-i18next';
import { SectionTitle } from '../Common/SectionTitle/SectionTitle';
import { AttachmentContainer, Container, EmptyMessageContainer, EmptyMessageText } from './styles';
import { CircularProgress, List } from '@mui/material';
import { FileListItem } from './Components/FileListItem';

interface AttachmentsBoxProps {
  files: AttachmentFile[];
  width?: string;
  title?: string;
  preventEdit?: boolean;
  isLoading?: boolean;
}

export const AttachmentsBox = ({ files, width, title, preventEdit, isLoading }: AttachmentsBoxProps) => {
  const { t } = useTranslation();
  const attachmentsTitle = t('attachments.title');
  return (
    <Container width={width}>
      <SectionTitle title={title ?? attachmentsTitle} />
      <AttachmentContainer>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </div>
        ) : (
          <List>
            {files.map((file) => (
              <FileListItem key={file.id} file={file} preventEdit={preventEdit} />
            ))}
            {!files.length && (
              <EmptyMessageContainer>
                <EmptyMessageText>No files uploaded yet</EmptyMessageText>
              </EmptyMessageContainer>
            )}
          </List>
        )}
      </AttachmentContainer>
    </Container>
  );
};
